import React from "react";
import {useTranslation} from "react-i18next";

interface Props {
    className?: string;
}
export default function NoRecords({ className }: Props) {
    const { t } = useTranslation("global")

    return (
        <div className={`mt-1 custom-card py-3 px-3 font-light text-[14px] ${className}`}>
            {t('no-records')}
        </div>
    )
}
